import { AddressController } from '@adornis/address/client/address-controller.js';
import { Address } from '@adornis/address/db/address.js';
import '@adornis/buchungsheld-theme/components/tr-dropdown-search-selection.js';
import { FormField } from '@adornis/formfield/form-field.js';
import { FormController } from '@adornis/forms/x-form-controller.js';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

@customElement('address-form')
export class AddressForm extends FormField<Address> {
  @property() label = 'Adresse';
  private _addressForm = new FormController(this, this.value.observable, {});
  private _address = new AddressController(this);

  protected override render() {
    return html`
      <x-flex flex>
        <x-flex>
          <tr-dropdown-search-selection
            placeholder="address"
            ${this._addressForm.field('address')}
            ${this._address.address()}
          ></tr-dropdown-search-selection>
        </x-flex>
        <x-flex horizontal space="sm" flex>
          <tr-dropdown-search-selection
            placeholder="zip"
            ${this._addressForm.field('zip')}
            ${this._address.zip()}
          ></tr-dropdown-search-selection>
          <tr-dropdown-search-selection
            flex
            placeholder="city"
            ${this._addressForm.field('city')}
            ${this._address.city()}
          ></tr-dropdown-search-selection>
        </x-flex>
      </x-flex>
    `;
  }
}
